module.exports = __webpack_public_path__ + "img/92147.fd0f2781.svg";